require('./accountDebitChangeStep1.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
//const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

const { formatText, FormattedText } = require('core/i18n').i18n;
// @ constants
const { HYPHEN, IBAN_PLACEHOLDER_2 } = require('constants');
const { ACCOUNTS } = require('constants/accounts');
const { FIRST_STEP } = require('constants/index');

// @helpers
const currencyHelper = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { formatIbanString } = require('commonsUtilities/stringHelper')

class AccountDebitChangeStep1 extends React.Component {

    constructor(props) {
        super(props);
        this.handleAccountFromChange = this.handleAccountFromChange.bind(this);
    }

    handleAccountFromChange(accountId) {
        const { setAccountId, validateStep } = this.props;
        if (accountId) {
            setAccountId(accountId);
            validateStep(FIRST_STEP);
        }
    }

    render() {
        const {
            match: { params: { accountId, receiptNumber } },
            immAccounts,
            filteredAccounts,
            immAccountDebits,
            clientName,
            immChangeReceiptAccount
        } = this.props;

        let content;
        if (immAccountDebits.hasIn([accountId, 'byId', receiptNumber]) && immAccounts) {

            const destinationAccountId = immChangeReceiptAccount.getIn(['steps', FIRST_STEP, 'destinationAccountId']);
            const firstStepError = immChangeReceiptAccount.getIn(['steps', FIRST_STEP, 'error']);

            const receipt = immAccountDebits.getIn([accountId, 'byId', receiptNumber]);
            const {
                beneficiaryName,
                issuingCompanyName,
                reference: { referenceNumber }
            } = receipt.toJS();

            const {
                newProduct: accountProductType,
                alias: currentAccountAlias,
                iban: currentAccountIban
            } = immAccounts.getIn(['byId', accountId]).toJS();
            const currentAccountIbanTrimmed = getLastNChars(currentAccountIban);
            const accountProductTypeText = ACCOUNTS[accountProductType];
            const clientNameFormatted = `<strong>${clientName}</strong>`;
            const accountNameLabel = `${currentAccountAlias}${currentAccountIbanTrimmed}${HYPHEN} ${accountProductTypeText}`;
            const blockInfoStrings = [
                issuingCompanyName,
                referenceNumber,
                beneficiaryName,
                currencyHelper.getFormattedString(receipt.get('amount')),
                formatIbanString(currentAccountIban),
                destinationAccountId ? formatIbanString(immAccounts.getIn(['byId', destinationAccountId, 'iban'])) : IBAN_PLACEHOLDER_2,
            ].map(text => `<strong>${text}</strong>`);

            content = (
                <div className="account-debit-change-step1">
                    <h4 className="account-debit-change-step1__title wizard-step--vertical__title no-print-out">
                        {formatText('accountDebitChange-step1Title')}
                    </h4>
                    <div className="account-debit-change-step1__main-content">
                        <OKInformativeList columns={1}>
                            <OKInformativeListItem
                                key={0}
                                className="account-debit-change-step1__item no-print-out"
                                title={formatText('accountDebitChange-actualDomiciliationLabel')}
                            >
                                <div className="account-debit-change-step1__value">
                                    {accountNameLabel}
                                </div>
                            </OKInformativeListItem>
                        </OKInformativeList>
                        <div id="sec_AccountDebitChangeStep1_AccountSelectContainer" className="account-debit-change-step1__dropdown-accounts no-print-out">
                            <DropdownAccounts
                                immAccounts={immAccounts.get('byId')}
                                currentAccountId={destinationAccountId}
                                accountsIndexes={filteredAccounts}
                                onAccountChange={this.handleAccountFromChange}
                                error={!!firstStepError}
                                errorMsg={firstStepError}
                                placeholder={formatText('accountDebitChange-dropDownPlaceHolder')}
                            />
                        </div>
                        <h4 className="account-debit-change-step1__title">
                            {formatText('accountDebitChange-step1changeConfirm')}
                        </h4>
                        <FormattedText
                            className="account-debit-change-step1__commission-label"
                            value="accountDebitChange-confirmationLabel"
                        />
                    </div>

                    <BlockInfo extraClass="account-debit-change-step1__block-info">
                        <FormattedText
                            value="accountDebitChange-blockInfoStep1Text1"
                            injectedStrings={[clientNameFormatted]}
                            className="account-debit-change-step1__formatted-text"
                        />
                        <FormattedText
                            value="accountDebitChange-blockInfoStep1Text2"
                            injectedStrings={blockInfoStrings}
                            className="account-debit-change-step1__formatted-text"
                        />
                        <FormattedText
                            value="accountDebitChange-blockInfoStep1Text3"
                            injectedStrings={[clientNameFormatted]}
                            className="account-debit-change-step1__formatted-text"
                        />
                    </BlockInfo>
                </div>
            )
        }
        return content;
    }
}

AccountDebitChangeStep1.propTypes = {
    immAccounts: PropTypes.object,
    immAccountDebits: PropTypes.object,
    immChangeReceiptAccount: PropTypes.object,
    clientName: PropTypes.string,
    filteredAccounts: PropTypes.array,
    setAccountId: PropTypes.func,
    match: PropTypes.object,
    validateStep: PropTypes.func,
};

module.exports.AccountDebitChangeStep1 = AccountDebitChangeStep1;
